<template>
  <div class="relative flex flex-col">
    <WebccLoaderOverlay v-if="isLoading" type="blocks" absolute />
    <button
      v-if="codes.length > 1"
      class="my-6 inline-block max-w-full rounded border border-thm p-4 text-thm hover:bg-thm hover:text-thm-contrast"
      @click="handleShowAllClick"
    >
      <span>{{ $t(`${trPrefix}showAllAccommodations`, codes.length) }}</span>
    </button>
    <div v-if="isOpen" class="flex flex-row flex-wrap justify-center gap-2">
      <WebccLink
        v-for="{ code, slug, name } in items"
        :key="code"
        :to="`/${slug ?? code}`"
        anchor
        class="snap-start rounded border-2 border-thm p-2 hover:bg-thm-hover hover:text-thm-contrast hover:border-thm-hover"
        :class="{ 'bg-thm text-thm-contrast': code === props.accom.code }"
      >
        <div class="p-2 text-sm">
          <strong class="mb-2">{{ name }}</strong>
          <span
            class="flex flex-auto items-center text-xs font-bold leading-none"
          >
            {{ code }}
          </span>
        </div>
      </WebccLink>
    </div>
  </div>
</template>

<script setup lang="ts">
const trPrefix = 'www.components.views.details.Residence.'

const props = defineProps<{
  accom: TranslatedAccommodation
}>()

const tracking = useTracking()
const [isOpen, toggle] = useToggle()

const codes = computed(() => props.accom.house?.accommodations ?? [])

const { data: items, isLoading } = useAccomsQuery(codes, { enabled: isOpen })

function handleShowAllClick() {
  tracking.handlers?.detail.houseAccommodationsClick(props.accom.code)
  toggle()
}
</script>
